/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createPagedResultOfProductFromDiscriminatorValue, createProductFromDiscriminatorValue, serializeCreateProductRequest, serializeProduct, type CreateProductRequest, type ErrorResponse, type InternalErrorResponse, type PagedResultOfProduct, type Product } from '../../models/index.js';
// @ts-ignore
import { ActivateRequestBuilderNavigationMetadata, type ActivateRequestBuilder } from './activate/index.js';
// @ts-ignore
import { BatchRequestBuilderRequestsMetadata, type BatchRequestBuilder } from './batch/index.js';
// @ts-ignore
import { BulkRequestBuilderRequestsMetadata, type BulkRequestBuilder } from './bulk/index.js';
// @ts-ignore
import { CategoriesRequestBuilderRequestsMetadata, type CategoriesRequestBuilder } from './categories/index.js';
// @ts-ignore
import { DeactivateRequestBuilderNavigationMetadata, type DeactivateRequestBuilder } from './deactivate/index.js';
// @ts-ignore
import { ImagesRequestBuilderRequestsMetadata, type ImagesRequestBuilder } from './images/index.js';
// @ts-ignore
import { type WithSkuItemRequestBuilder, WithSkuItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { PricesRequestBuilderRequestsMetadata, type PricesRequestBuilder } from './prices/index.js';
// @ts-ignore
import { ReorderRequestBuilderRequestsMetadata, type ReorderRequestBuilder } from './reorder/index.js';
// @ts-ignore
import { SearchRequestBuilderRequestsMetadata, type SearchRequestBuilder } from './search/index.js';
// @ts-ignore
import { SortordersRequestBuilderRequestsMetadata, type SortordersRequestBuilder } from './sortorders/index.js';
// @ts-ignore
import { TagsRequestBuilderRequestsMetadata, type TagsRequestBuilder } from './tags/index.js';
// @ts-ignore
import { type UpdateRequestBuilder, UpdateRequestBuilderRequestsMetadata } from './update/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/products
 */
export interface ProductsRequestBuilder extends BaseRequestBuilder<ProductsRequestBuilder> {
    /**
     * The activate property
     */
    get activate(): ActivateRequestBuilder;
    /**
     * The batch property
     */
    get batch(): BatchRequestBuilder;
    /**
     * The bulk property
     */
    get bulk(): BulkRequestBuilder;
    /**
     * The categories property
     */
    get categories(): CategoriesRequestBuilder;
    /**
     * The deactivate property
     */
    get deactivate(): DeactivateRequestBuilder;
    /**
     * The images property
     */
    get images(): ImagesRequestBuilder;
    /**
     * The prices property
     */
    get prices(): PricesRequestBuilder;
    /**
     * The reorder property
     */
    get reorder(): ReorderRequestBuilder;
    /**
     * The search property
     */
    get search(): SearchRequestBuilder;
    /**
     * The sortorders property
     */
    get sortorders(): SortordersRequestBuilder;
    /**
     * The tags property
     */
    get tags(): TagsRequestBuilder;
    /**
     * The update property
     */
    get update(): UpdateRequestBuilder;
    /**
     * Gets an item from the MomentumAPI.api.products.item collection
     * @param sku Unique identifier of the item
     * @returns {WithSkuItemRequestBuilder}
     */
     bySku(sku: string) : WithSkuItemRequestBuilder;
    /**
     * List Products
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagedResultOfProduct>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<ProductsRequestBuilderGetQueryParameters> | undefined) : Promise<PagedResultOfProduct | undefined>;
    /**
     * Create a Product using an upsert based on Sku. For an agency organization a vendorCode names the line the product belongs to, and the SKU is stored as {vendorCode}-{sku}; a value already carrying the prefix is left alone.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Product>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: CreateProductRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Product | undefined>;
    /**
     * List Products
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ProductsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * Create a Product using an upsert based on Sku. For an agency organization a vendorCode names the line the product belongs to, and the SKU is stored as {vendorCode}-{sku}; a value already carrying the prefix is left alone.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: CreateProductRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * List Products
 */
export interface ProductsRequestBuilderGetQueryParameters {
    /**
     * Gets or sets the filters for the request, this is optionalAcceptable operators are: starts with, contains, not contains, ends with, equals, not equals
     */
    filters?: string[];
    /**
     * Optional image-presence filter: true returns only products with at least one image,false returns only products with no images, omitted applies no image filtering.A dedicated parameter (not a QueryFilter) because filter operators are coerced to Contains.
     */
    hasImages?: boolean;
    /**
     * Gets or sets the page number for the request. Default value is 1.
     */
    pageNumber?: number;
    /**
     * Gets or sets the page size for the request. Default value is 25.
     */
    pageSize?: number;
    /**
     * Gets or sets the sort direction. Can be "ASC" or "DESC". Default value is "asc".
     */
    sortDirection?: string;
    /**
     * Gets or sets the field to sort on. Default value is "RepNumber".
     */
    sortOn?: string;
    /**
     * Optional tag filter: returns only products carrying this tag. Matching is on the storednormalized (trimmed, UPPERCASE) tag form, so the value is case-insensitive; blank appliesno tag filtering. A dedicated parameter (not a QueryFilter) because tags are an array andfilter operators are coerced to Contains, which cannot express array membership.
     */
    tag?: string;
}
/**
 * Uri template for the request builder.
 */
export const ProductsRequestBuilderUriTemplate = "{+baseurl}/api/products?filters={filters}&pageNumber={pageNumber}&pageSize={pageSize}&sortDirection={sortDirection}&sortOn={sortOn}&tag={tag}{&hasImages*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ProductsRequestBuilderNavigationMetadata: Record<Exclude<keyof ProductsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    bySku: {
        requestsMetadata: WithSkuItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["sku"],
    },
    activate: {
        navigationMetadata: ActivateRequestBuilderNavigationMetadata,
    },
    batch: {
        requestsMetadata: BatchRequestBuilderRequestsMetadata,
    },
    bulk: {
        requestsMetadata: BulkRequestBuilderRequestsMetadata,
    },
    categories: {
        requestsMetadata: CategoriesRequestBuilderRequestsMetadata,
    },
    deactivate: {
        navigationMetadata: DeactivateRequestBuilderNavigationMetadata,
    },
    images: {
        requestsMetadata: ImagesRequestBuilderRequestsMetadata,
    },
    prices: {
        requestsMetadata: PricesRequestBuilderRequestsMetadata,
    },
    reorder: {
        requestsMetadata: ReorderRequestBuilderRequestsMetadata,
    },
    search: {
        requestsMetadata: SearchRequestBuilderRequestsMetadata,
    },
    sortorders: {
        requestsMetadata: SortordersRequestBuilderRequestsMetadata,
    },
    tags: {
        requestsMetadata: TagsRequestBuilderRequestsMetadata,
    },
    update: {
        requestsMetadata: UpdateRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ProductsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ProductsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagedResultOfProductFromDiscriminatorValue,
    },
    put: {
        uriTemplate: ProductsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createProductFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateProductRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
